import HouseholdAddMember from '../../../components/HouseholdAddMember';
import SelectorEngine from '../../..//utils/dom/selector-engine';

const SELECTOR_WRAPPER = '.p-add-household-member-page';

class HouseHoldAccountsAddMemberPage {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (this._wrapper) {
			this.init();
		}
	}

	init() {
		this.component = new HouseholdAddMember();

		if (this.component.isReady()) {
			this.component.open();
		}
	}
}

const globalHouseHoldAccountsAddMemberPage = new HouseHoldAccountsAddMemberPage();
export default globalHouseHoldAccountsAddMemberPage;
